// ICONS
import { House, UserRound, Megaphone, Layout, Calendar, Folder, Shield } from 'lucide-react'

const menuItems = [
    {
        label: 'Dashboard',
        path: '/admin/dashboard',
        icon: House,
        children: [
            { label: 'Analyses', path: '/admin/dashboard/analytics', requiresSuperAdmin: false },
        ],
    },
    {
        label: 'Utilisateurs',
        path: '/admin/users',
        icon: UserRound,
        children: [
            { label: 'Liste', path: '/admin/users/list', requiresSuperAdmin: false }
        ],
    },
    {
        label: 'Tuiles',
        path: '/admin/tiles',
        icon: Layout,
        children: [
            { label: 'Gestion', path: '/admin/tiles/management', requiresSuperAdmin: false },
            { label: 'Disposition', path: '/admin/tiles/layout', requiresSuperAdmin: false },
            { label: 'Propositions', path: '/admin/tiles/proposals', requiresSuperAdmin: false },
        ],
    },
    {
        label: 'Annonces',
        path: '/admin/announcements',
        icon: Megaphone,
        children: [
            { label: 'Historique', path: '/admin/announcements/history', requiresSuperAdmin: false },
            { label: 'Gestion', path: '/admin/announcements/management', requiresSuperAdmin: false },
        ],
    },
    {
        label: 'Évènements',
        path: '/admin/events',
        icon: Calendar,
        children: [
            { label: 'Gestion', path: '/admin/events/management', requiresSuperAdmin: false },
        ],
    },
    {
        label: 'Ressources',
        path: '/admin/resources',
        icon: Folder,
        children: [
            { label: 'Gestion', path: '/admin/resources/management', requiresSuperAdmin: false },
        ],
    },
    {
        label: 'Super Admin',
        path: '/admin/super-admin',
        icon: Shield,
        requiresSuperAdmin: true,
        children: [
            { label: 'Logs', path: '/admin/super-admin/logs', requiresSuperAdmin: true },
            { label: 'Paramètres', path: '/admin/super-admin/settings', requiresSuperAdmin: false },
        ],
    }
];

export default menuItems;